/**
 * Additional config whitelist extending the original whitelist in the case where jitsi-meet is loaded in an iframe.
 */
export default [];
